/**
 * The Room picker's option value: one option per room and rig, `${roomId}:${rigId}` (a room with no rig
 * offers `${roomId}:`). The live-journey runner (`scripts/run-live-journeys.mjs`) selects options by this
 * same value; `scripts/run-live-journeys.test.ts` pins the two together.
 */
export function roomOptionValue(roomId: string, rigId: string): string {
  return `${roomId}:${rigId}`;
}
